import { Inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { Environment } from "../classes/environment";


declare var grecaptcha: any;


@Injectable({ providedIn: 'root' })
export class MyReCaptchaService {


	private bIsInit = false;


	constructor(
		@Inject("environment") private environment: Environment
	) {}


	initialize(): Observable<boolean> {

		if( this.bIsInit ) return of(true);

		if( !this.environment.recaptchaKey || !this.environment.recaptchaKey.length ) {
			console.error( "no reCaptchakey", this.environment.recaptchaKey );
			return of(false);
		}

		return new Observable( subscriber => {
			const script = document.createElement('script');
			script.src = `https://www.google.com/recaptcha/api.js?render=${this.environment.recaptchaKey}` + "&hl=de";
			script.async = true;
			script.defer = true;
			script.onload = () => {
				this.bIsInit = true;
				subscriber.next(true);
				subscriber.complete();
			};
			script.onerror = (e) => {
				console.error( 'Error loading reCAPTCHA script:', e );
				subscriber.error(e);
			};
			document.body.appendChild(script);
		});

	}

	getToken( action: string ): Observable<string> {

		if( !this.environment.recaptchaKey ) {
			console.warn( "reCAPTCHA is disabled due to an empty key" );
			return of("");
		}

		if( !this.bIsInit ) {
			console.warn("reCAPTCHA library not initialized");
			return of("");
		}

		return new Observable( subscriber => {
			grecaptcha.ready(() => {
				grecaptcha.execute( this.environment.recaptchaKey, { action: action } )
					.then( (token: string) => {
						subscriber.next(token);
						subscriber.complete();
					})
					.catch((error: unknown) => {
						console.error( "Error generating reCAPTCHA token:", error );
						subscriber.error(error);
					});
			});
		});

	}


	isRecaptchaActive(): boolean {
		return this.environment.recaptchaActive;
	}

}